<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <settingsMenu></settingsMenu>
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Grupy artykułów</h4>
              <button v-if="hasPermission('canEditUbrania')" @click="addGrupa" class="btn btn-primary btn-sm">
                <i class="bi bi-plus-circle me-2"></i>Dodaj nową grupę
              </button>
              <button v-if="hasPermission('canEditUbrania')" @click="openRodzajModal"
                      class="btn btn-outline-primary btn-sm ms-2">
                <i class="bi bi-plus-circle me-2"></i>Rodzaje
              </button>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="custom-table">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Nazwa grupy</th>
                  <th>Opis</th>
                  <th>Rodzaj</th>
                  <th v-if="hasPermission('canEditUbrania')">Akcje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="addingNew">
                  <td>Nowa</td>
                  <td><input v-model="newGrupa.nazwa" class="form-control" style="min-width:200px;"/></td>
                  <td><input v-model="newGrupa.opis" class="form-control" style="min-width:200px;"/></td>
                  <td>
                    <select v-model="newGrupa.typ" class="form-select form-select-sm" style="min-width:200px;">
                      <option disabled value="">-- Wybierz rodzaj --</option>
                      <option v-for="t in typy" :key="t.id" :value="t.id">{{ t.nazwa }}</option>
                    </select>
                  </td>
                  <td>
                    <button @click="saveNewGrupa" class="btn btn-sm btn-success me-1"><i class="bi bi-save me-2"></i>Zapisz
                    </button>
                    <button @click="cancelNewGrupa" class="btn btn-sm btn-danger"><i class="bi bi-x-circle me-2"></i>Anuluj
                    </button>
                  </td>
                </tr>

                <tr v-for="(grupa, index) in grupy" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <input v-if="editingId === grupa.id" v-model="grupa.nazwa" class="form-control"/>
                    <span v-else>{{ grupa.nazwa }}</span>
                  </td>
                  <td>
                    <input v-if="editingId === grupa.id" v-model="grupa.opis" class="form-control"/>
                    <span v-else>{{ grupa.opis }}</span>
                  </td>
                  <td>
                    <select v-if="editingId === grupa.id" v-model="grupa.typ" class="form-select form-select-sm">
                      <option disabled value="">-- Wybierz rodzaj --</option>
                      <option v-for="t in typy" :key="t.id" :value="t.id">{{ t.nazwa }}</option>
                    </select>
                    <span v-else>
						{{ getTypGrupy(grupa.typ) }}
					  </span>
                  </td>
                  <td v-if="hasPermission('canEditUbrania')">
                    <button v-if="editingId === grupa.id" @click="updateGrupa(grupa)"
                            class="btn btn-sm btn-success me-2">Zapisz
                    </button>
                    <button v-else @click="editGrupa(grupa.id)" class="btn btn-sm btn-outline-info me-2"><i
                        class="bi bi-pencil me-2"></i>Edytuj
                    </button>
                    <button @click="deleteGrupa(grupa.id)" class="btn btn-sm btn-danger"><i
                        class="bi bi-trash me-2"></i>Usuń
                    </button>
                  </td>
                </tr>

                </tbody>
              </table>
            </div>
          </div>

          <div v-if="isModalOpenAddRodzaj" class="modal fade show" tabindex="-1" style="display: block;">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Rodzaje</h5>
                  <button type="button" class="btn-close" @click="closeRodzajModal"></button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12">
                      <button @click="addNewRodzaj" class="btn btn-success btn-sm mb-2"><i
                          class="bi bi-plus-circle me-2"></i>Dodaj nowy rodzaj
                      </button>
                      <div v-if="addingNew" class="row">
                        <div class="col-md-12 col-lg-12 mb-3">
                          <label class="form-label" for="Rodzajnazwa">Nazwa:</label>
                          <input id="Rodzajnazwa" v-model="newRodzaj.nazwa" type="text" class="form-control"
                                 style="border-radius: 0;"/>
                        </div>
                        <div class="modal-footer">
                          <button @click="saveRodzaj" class="btn btn-sm btn-outline-success"><i
                              class="bi bi-save me-2"></i>Zapisz
                          </button>
                          <button @click="cancelNewRodzaj" class="btn btn-sm btn-outline-primary"><i
                              class="bi bi-x-circle me-2"></i>Anuluj
                          </button>
                        </div>
                      </div>
                      <div v-if="editingRodzajId === editedRodzaj.id" class="row">
                        <div class="col-md-12 col-lg-12 mb-3">
                          <label class="form-label" for="nazwa">Nazwa:</label>
                          <input id="nazwa" v-model="editedRodzaj.nazwa" type="text" class="form-control"
                                 style="border-radius: 0;"/>
                        </div>
                        <div class="modal-footer">
                          <button @click="updateRodzaj(editedRodzaj)" class="btn btn-sm btn-outline-success"><i
                              class="bi bi-save me-2"></i>Zapisz
                          </button>
                          <button @click="cancelEditRodzaj" class="btn btn-sm btn-outline-primary"><i
                              class="bi bi-x-circle me-2"></i>Anuluj
                          </button>
                        </div>
                      </div>
                      <div class="custom-table ">
                        <div class="table-responsive">
                          <table class="table table-hover">
                            <thead>
                            <tr>
                              <th>#</th>
                              <th>Nazwa</th>
                              <th>Akcje</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(typ, index) in typy" :key="index">
                              <td>{{ index + 1 }}</td>
                              <td>{{ typ.nazwa }}</td>
                              <td style="width: 80px;" class="text-center">
                                <button v-if="editingRodzajId === typ.id" @click="updateRodzaj(typ)"
                                        class="btn btn-sm btn-success me-2 mb-2">Zapisz
                                </button>
                                <button @click="editRodzaj(typ)" class="btn btn-sm btn-outline-info me-2 mb-2"><i
                                    class="bi bi-pencil me-2"></i>Edytuj
                                </button>
                                <br>
                                <button @click="deleteRodzaj(typ.id)" class="btn btn-sm btn-danger"><i
                                    class="bi bi-trash me-2"></i>Usuń
                                </button>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import settingsMenu from "@/Pages/BHP/parts/settingsMenu.vue";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, settingsMenu},
  props: {
    grupy: Array,
    typy: Array
  },
  data() {
    return {
      hasPermission,
      editingId: null,
      editingRodzajId: null,
      editedRodzaj: {},
      addingNew: false,
      newGrupa: this.getEmptyForm(),
      newRodzaj: this.getEmptyFormRodzaj(),
      isModalOpenAddRodzaj: false
    };
  },
  methods: {

    updateRodzaj(rodzaj) {
      this.editedRodzaj = {...rodzaj};
      this.$inertia.put(route('bhp.grupy.rodzaj.update', rodzaj.id), rodzaj, {
        onSuccess: () => {
          this.editingRodzajId = null;
        }
      });
    },

    addNewRodzaj() {
      this.addingNew = true;
      this.newRodzaj = this.getEmptyFormRodzaj();
    },

    cancelNewRodzaj() {
      this.addingNew = false;
      this.newRodzaj = this.getEmptyFormRodzaj();
    },

    saveRodzaj() {
      this.$inertia.post(route('bhp.grupy.rodzaj.dodaj'), this.newRodzaj, {
        onSuccess: () => {
          this.newRodzaj = this.getEmptyFormRodzaj();
        }
      });
    },
    deleteRodzaj(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie rodzaju grupy',
        html: 'Czy na pewno chcesz usunąć wybrany rodzaj?',
        showDenyButton: true,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('bhp.grupy.rodzaj.usun', id));
        }
      })
    },
    closeRodzajModal() {
      this.isModalOpenAddRodzaj = false;
      this.newRodzaj = this.getEmptyFormRodzaj();
    },

    openRodzajModal() {
      this.isModalOpenAddRodzaj = true;
    },

    getTypGrupy(id) {
      const rodzaj = this.typy.find(r => r.id === id);
      return rodzaj ? rodzaj.nazwa : '';
    },
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return date.toISOString().split('T')[0];
    },
    getEmptyForm() {
      return {
        id: null,
        name: '',
        opis: '',
        ile_wczesniej: 14,
        typ: 0,
        check_position: 1,
      };
    },
    getEmptyFormRodzaj() {
      return {
        id: null,
        nazwa: '',
      };
    },
    addGrupa() {
      this.addingNew = true;
      this.newGrupa = this.getEmptyForm();
    },
    cancelNewGrupa() {
      this.addingNew = false;
      this.newGrupa = this.getEmptyForm();
    },
    editGrupa(id) {
      this.editingId = id;
    },
    cancelEditRodzaj() {
      this.editingRodzajId = null;
    },

    editRodzaj(rodzaj) {
      this.editingRodzajId = rodzaj.id;
      this.editedRodzaj = {...rodzaj};
    },
    updateGrupa(grupa) {
      this.$inertia.put(route('bhp.grupy.update', grupa.id), grupa, {
        onSuccess: () => {
          this.editingId = null;
        }
      });
    },
    saveNewGrupa() {
      this.$inertia.post(route('bhp.grupy.dodaj'), this.newGrupa, {
        onSuccess: () => {
          this.addingNew = false;
          this.newGrupa = this.getEmptyForm();
        }
      });
    },
    deleteGrupa(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie grupy produktów',
        html: 'Czy na pewno chcesz usunąć wybraną grupę produktów?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('bhp.grupy.usun', id));
        }
      });
    }
  }
};
</script>
